import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DependentModule } from "../shared/dependent.module";
import { EBEComponent } from './EBE.component';
import { EnrichmentTabsComponent } from '../bookShared/enrichmentTabs/enrichmentTabs.component';
import { BookeditoptionComponent } from '../bookShared/bookeditoption/bookeditoption.component';
import { AddEnrichmentOptionsComponent } from '../bookShared/enrichmentTabs/enrichmentTabPopups/AddEnrichmentOptions/addEnrichmentOptions.component';
import { ColorPickerComponent } from '../bookShared/popups/colorPicker/colorPicker.component';
import { TyphographyComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/text/typhography/typhography.component';
import { PageEnrichmentsComponent } from '../bookShared/popups/pageEnrichments/pageEnrichments.component';
import { PalleteComponent } from '../bookShared/popups/pallete/pallete.component';
import { ParentviewComponent } from '../bookShared/enrichmentTabs/enrichmentTabPopups/parentview/parentview.component';
import { SmartviewComponent } from '../bookShared/popups/smartview/smartview.component';
import { MindmapComponent } from '../bookShared/popups/mindmap/mindmap.component';
import { MiniBookComponent } from '../bookShared/popups/mini-book/mini-book.component';
import { BookmoreoptionsComponent } from '../bookShared/popups/bookmoreoptions/bookmoreoptions.component';
import { PagesIndexComponent } from '../bookShared/enrichmentTabs/enrichmentTabPopups/pagesIndex/pagesIndex.component';
import { PagenopositionComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/pagenoposition/pagenoposition.component';
import { FillupquestionComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/question/fillupquestion/fillupquestion.component';
import { TruefalsequestionComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/question/truefalsequestion/truefalsequestion.component';
import { SymbolComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/text/symbol/symbol.component';
import { NoteComponent } from '../bookShared/popups/Note/Note.component';
import { InlineimageComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/text/media/inlineimage/inlineimage.component"

import { TextimageComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/text/media/textimage/textimage.component"

import { InternetSearchEnrichmentsComponent } from '../bookShared/enrichmentTabs/internet-search-enrichments/internet-search-enrichments.component';
import { EBEpouchdbService } from './EBEpouchdb.service';
import { ELEpouchdbService } from '../ELE/ELE.pouchdb.service'

import { PageCreationComponent } from '../bookShared/popups/pageCreation/pageCreation.component';
import { EditorComponent } from '../bookShared/editor/editor.component';
import { YoutubeSearchEnrichmentsComponent } from '../bookShared/enrichmentTabs/youtube-search-enrichments/youtube-search-enrichments.component';
import { SafePipe } from './safePipe';
import { ELEComponent } from '../ELE/ELE.component';
import { GoogleSpreadsheetEnrichmentComponent } from '../bookShared/enrichmentTabs/google-spreadsheet-enrichment/google-spreadsheet-enrichment.component';
// import { GoogleService } from '../shelf/googleDrive/Google.service';
import { PageFromBookEnrichmentComponent } from '../bookShared/enrichmentTabs/page-from-book-enrichment/page-from-book-enrichment.component';
import { MediacategoriesComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/mediacategories/mediacategories.component";
import { PagebackgroundcolorComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/pagebackgroundcolor/pagebackgroundcolor.component";
import { MediacommonComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/mediacommon/mediacommon.component"
import { EditorService } from "../bookShared/bookeditoption/editor.service";
import { ImageGallerymediaComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/media/image/imageGallerymedia/imageGallerymedia.component";
import { MediavideocommonComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/mediavideocommon/mediavideocommon.component";
import { VideogallerymediaComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/media/video/videogallerymedia/videogallerymedia.component";
import { CommonaudioComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/commonaudio/commonaudio.component";
import { AudiomediaComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/media/audio/audiomedia/audiomedia.component";
import { EnrichmentTabsService } from '../bookShared/enrichmentTabs/enrichmentTabs.service';
import { EditOptionService } from '../bookShared/bookeditoption/editOptions.service';
import { DialogOverviewExampleDialog } from "../bookShared/bookeditoption/bookeditoption.component";
// import { TemplateAsEnrichmentComponent } from '../bookShared/enrichmentTabs/template-as-enrichment/template-as-enrichment.component';
import { CreateTemplateDialogueComponent } from '../bookShared/popups/create-template-dialogue/create-template-dialogue.component';
import { DeletePopupComponent } from '../shared/deletePopup/deletePopup.component';
import { FullviewComponent } from '../bookShared/fullView/fullview.component';
import { ShapecolorComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/text/shapecolor/shapecolor.component';
import { BookInfoComponent } from '../bookShared/popups/bookInfo/bookInfo.component';
import { donwloadEleService } from '../bookShared/downloadELE.service'
import { UrlComponent } from "../bookShared/bookeditoption/bookEditOptionPopups/media/url/url.component";
import { MultipleselectComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/question/multipleselect/multipleselect.component';
import { FillupwithoptionComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/question/fillupwithoption/fillupwithoption.component';
import { PdfFullViewComponent } from '../bookShared/pdf-fullView/pdf-fullView.component';

import { DrawingcardcolorComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/drawingcardcolor/drawingcardcolor.component'
@NgModule({
  imports: [
    CommonModule,
    DependentModule,
  ],
  declarations: [EBEComponent,
    EnrichmentTabsComponent,
    BookeditoptionComponent,
    AddEnrichmentOptionsComponent,
    ColorPickerComponent,
    TyphographyComponent,
    PageEnrichmentsComponent,
    PalleteComponent,
    ParentviewComponent,
    SmartviewComponent,
    NoteComponent,
    MindmapComponent,
    MiniBookComponent,
    BookmoreoptionsComponent,
    PagesIndexComponent,
    PagenopositionComponent,
    FillupquestionComponent,
    TruefalsequestionComponent,
    SymbolComponent,
    InternetSearchEnrichmentsComponent,
    PageCreationComponent,
    InlineimageComponent,
    TextimageComponent,
    EditorComponent,
    YoutubeSearchEnrichmentsComponent,
    SafePipe,
    ELEComponent,
    GoogleSpreadsheetEnrichmentComponent,
    PageFromBookEnrichmentComponent,
    MediacategoriesComponent,
    PagebackgroundcolorComponent,
    MediacommonComponent,
    ImageGallerymediaComponent,
    MediavideocommonComponent,
    VideogallerymediaComponent,
    CommonaudioComponent,
    AudiomediaComponent,
    DialogOverviewExampleDialog,

    CreateTemplateDialogueComponent,
    DeletePopupComponent,
    FullviewComponent,
    ShapecolorComponent,
    BookInfoComponent,
    UrlComponent,
    MultipleselectComponent,
    FillupwithoptionComponent,
    PdfFullViewComponent,
    DrawingcardcolorComponent
  ],
  providers: [EBEpouchdbService, ELEpouchdbService, EditorService, EnrichmentTabsService, EditOptionService, donwloadEleService],
  entryComponents: [EBEComponent,
    AddEnrichmentOptionsComponent,
    ColorPickerComponent,
    TyphographyComponent,
    PageEnrichmentsComponent, PalleteComponent, ParentviewComponent, SmartviewComponent, MindmapComponent, MiniBookComponent, BookmoreoptionsComponent, NoteComponent,
    PagesIndexComponent, PagenopositionComponent, FillupquestionComponent, TruefalsequestionComponent,
    SymbolComponent, InternetSearchEnrichmentsComponent, PageCreationComponent, InlineimageComponent,
    TextimageComponent, EditorComponent, YoutubeSearchEnrichmentsComponent, ELEComponent,
    GoogleSpreadsheetEnrichmentComponent, PageFromBookEnrichmentComponent, MediacategoriesComponent, PagebackgroundcolorComponent, ImageGallerymediaComponent, VideogallerymediaComponent, AudiomediaComponent, DialogOverviewExampleDialog, CreateTemplateDialogueComponent,
    DeletePopupComponent, FullviewComponent, ShapecolorComponent, BookInfoComponent, UrlComponent, MultipleselectComponent,
    FillupwithoptionComponent, PdfFullViewComponent, DrawingcardcolorComponent
  ],
})
//
export class EBEModule { }


// WEBPACK FOOTER //
// ./src/app/EBE/EBE.module.ts